import { EquipmentExtended } from '@frontend/equipment/types';
import { ICONS } from '@frontend/icons';

import { useEquipmentCard } from './equipment-card.controller';

export interface EquipmentCardProps {
    equipment?: EquipmentExtended;
    equipment_id?: string;
    onClick?: () => void;
    styles?: {
        container?: string;
    };
}

export const EquipmentCard = (props: EquipmentCardProps) => {
    const viewProps = useEquipmentCard(props);

    return (
        <div
            className={`bg-background-surface border-border-default inline-flex items-start justify-start gap-2 self-stretch rounded-xl border p-3 ${props.styles?.container ?? ''}`}
            onClick={props.onClick}>
            <div className='inline-flex h-5 w-5 flex-col items-center justify-center gap-2.5'>
                <div className='relative h-4 w-4 overflow-hidden'>
                    <ICONS.NAVIGATION.EQUIPMENT />
                </div>
            </div>
            <div className='text-foreground-default flex-1 justify-start text-base font-medium'>{viewProps.display}</div>
        </div>
    );
};
